import fieldMetaData, { IEnumMeta } from '../graphql/schema/fieldMetaData';
import { ReportOutputType, ReportTemplateFormat } from '../graphql/schema/p4types';

export const getAvailableReportOutputTypes = (format: ReportTemplateFormat): Array<IEnumMeta<ReportOutputType>> => {
  if (format === ReportTemplateFormat.Handlebars) {
    return [
      {
        value: ReportOutputType.Email,
        label: 'E-Mail',
      },
      {
        value: ReportOutputType.LocalPrinter,
        label: 'Local Printer',
      },
    ];
  } else {
    return fieldMetaData.DocumentOutputType.enumValues;
  }
};
